import { safetyMargins } from '@bedrock-rdk/constants';
import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(PRIMARY),
  text: makeThemeColor(TERTIARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Image: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
    },
    AdLabel: {
      mountX: 1,
      x: v => v - safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      displayIcon: false,
    },
    Resume: {
      mount: 1,
      x: v => v - safetyMargins.horizontal[screenSize],
      y: v => v - safetyMargins.vertical[screenSize],
      backgroundColor: colors.background[colorMode],
      textColor: colors.text[colorMode],
    },
  };
};
